export default function TermsOfUse() {
  return (
    <div className="w-full bg-white text-gray-800 py-16">
      <div className="max-w-5xl mx-auto px-6">

        <h1 className="text-4xl font-bold mb-6">Terms of Use</h1>
        <p className="text-gray-600 mb-8">Last updated: January 2025</p>

        <div className="space-y-8 leading-relaxed">

          <section>
            <h2 className="text-2xl font-semibold mb-3">1. Introduction</h2>
            <p>
              Welcome to Smarty, a learning platform operated by Accennovate Tech Solutions.  
              By using our services, you agree to these Terms of Use.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">2. Eligibility</h2>
            <p>
              You must be at least 18 years old or use the platform with parental supervision.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">3. Your Account</h2>
            <p>
              You are responsible for maintaining your account security and notifying us of any unauthorized use.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">4. Use of the Platform</h2>
            <ul className="list-disc ml-6 space-y-1">
              <li>No reselling or sharing course content.</li>
              <li>No uploading harmful or illegal content.</li>
              <li>No attempts to bypass security or disrupt the platform.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">5. Course Enrollment</h2>
            <p>
              A course purchase gives you a limited, non-transferable personal license to view the content.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">6. Payments & Refunds</h2>
            <p>
              All purchases are final unless otherwise clearly stated during checkout.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">7. Intellectual Property</h2>
            <p>
              All videos, documents, and assets on Smarty are protected by copyright laws.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">8. Instructor Responsibilities</h2>
            <p>
              Instructors must upload original content and grant Smarty a license to host it.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">9. Account Termination</h2>
            <p>
              We reserve the right to suspend or terminate accounts that violate our policies.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">10. Limitation of Liability</h2>
            <p>
              Smarty is not responsible for damages caused by service interruptions or misuse.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">11. Updates to Terms</h2>
            <p>
              These terms may be updated at any time. Continued use indicates acceptance.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold mb-3">12. Contact Us</h2>
            <p>
              For questions, contact us at:<br />
              <strong>Email:</strong> support@accennovate.com
            </p>
          </section>

        </div>
      </div>
    </div>
  );
}
